// extracted by mini-css-extract-plugin
export default {"dropzone":"DragAndDropFiles_dropzone__CGS24","highlightedText":"DragAndDropFiles_highlightedText__O7MYt","guidelineText":"DragAndDropFiles_guidelineText__9Ilkc"};